export class MsaAcceptanceResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "signedAt",
            "baseName": "signedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "signedByEmail",
            "baseName": "signedByEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MsaAcceptanceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
